<template>
  <!-- 资质审核 -->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="applyId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
    >
    </x-tabula>

    <a-modal
      title="批量审核"
      :visible="visible"
      @cancel="closeFun"
      @ok="okFun"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      :width="550"
    >
      <x-addEdit
        ref="addEdit"
        modalType="modal"
        :itemLayout="$store.state.modal_ItemLayout"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
      />
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import { Modal } from 'ant-design-vue';
import { empty } from 'ant-design-vue-admin-x';
export default {
  name: 'qualification',
  mixins: [fetchSelect],
  components: {},
  data () {
    return {
      id: undefined,
      visible: false,
      btnLoading: { loading: false },
      scrollWidth: { x: 1800 },
      searchList: [
        {
          props: ['shopName'],
          placeholder: '门店名称',
          options: [],
          inputType: 'input'
        },
        {
          props: ['checkStatus'],
          placeholder: '状态',
          options: [
            // {label: '待审核', value: '1'},
            // {label: '已驳回', value: '2'},
            // {label: '已通过', value: '3'}
          ],
          inputType: 'select'
        },
        {
          label: '',
          props: ['areas'],
          placeholder: '所在地区',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(2, 'searchList', '1,2', e);
          }
        },
        {
          props: ['mobilePhone'],
          placeholder: '账号',
          options: [],
          inputType: 'input'
        }
      ],
      tableOptList: [
        {
          text: '审核',
          disabled: true,
          permi: ['community:localShopApply:edit'],
          handle: (selectid, rows) => {
            let newrow = rows.filter(row => row.checkStatus == 1);
            if (newrow.length == 0) {
              Modal.error({
                content: '没有可审核的数据！'
              });
              return;
            }
            let str = `确定要审核${newrow.length}条数据？`;
            if (rows.length > newrow.length) {
              let diff = rows.length - newrow.length;
              str = str + `其中${diff}条数据不可审核。`;
            }
            let that = this;
            Modal.confirm({
              content: str,
              okText: '确认',
              cancelText: '取消',
              onOk () {
                let ids = newrow.map(row => row.applyId).toString();
                that.id = ids.toString();
                that.visible = true;
              }
            });
          }
        }
      ],
      rowOptList: [
        {
          text: '',
          handle: (row) => this.goDetail(row.applyId, row.checkStatus),
          key: '',
          rowOptText: row => {
            if (row.checkStatus == 1) { return '审核'; } else { return '查看'; }
          },
          customRender: true,
          permi: ['community:localShopApply:detail']
        }
      ],
      columns: [
        {
          title: '所在地区',
          dataIndex: 'area',
          align: ''
          // width: '100'
        },
        {
          title: '门店名称',
          dataIndex: 'shopName',
          align: ''
          // width: '200'
        },
        {
          title: '账号',
          dataIndex: 'mobilePhone',
          align: ''
          // width: '200'
        },
        {
          title: '主营类目',
          dataIndex: 'categoryName',
          align: ''
          // width: '200'
        },
        {
          title: '入驻类型',
          dataIndex: 'applyTypeDesc',
          align: ''
          // width: '200'
        },
        {
          title: '申请时间',
          dataIndex: 'applyTime',
          align: ''
          // width: '200'
        },
        {
          title: '状态',
          dataIndex: 'checkStatusDesc',
          align: ''
          // width: '200',
          // scopedSlots: { customRender: 'onlineStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '100',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      searchParams: {
        shopName: undefined,
        checkStatus: undefined,
        areas: undefined,
        mobilePhone: undefined
      },
      formList: [
        {
          label: '审核结果',
          inputType: 'select',
          options: [
            {
              label: '通过',
              value: 3
            },
            {
              label: '驳回',
              value: 2
            }

          ],
          handle: (val) => {
            if (val == 3) {
              this.formList[1].isShow = false;
            } else {
              this.formList[1].isShow = true;
            }
          },
          placeholder: '选择',
          props: [
            'checkStatus',
            {
              rules: [{ required: true, message: '请选择审核结果' }]
            }
          ]
        },
        {
          isShow: false,
          label: '驳回原因',
          inputType: 'textarea',
          options: [],
          handle: '',
          placeholder: '请至少输入五个字符',
          props: [
            'qfRejectRemark',
            {
              rules: [{ required: true, message: '请输入驳回原因' },
                { min: 5, message: '驳回原因最少5个字' },
                {pattern: /^([\s]*[\S]+[\s]*[\S]*)+$/, message: '不能为空'}]
            }
          ]
        }
      ],

      listApi: {
        url: '/local/shopApply/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },

  created () {
    this.regionSelect(2);
    this.getSelect();
    empty.$on('update_qualification', () => {
      this.$refs.table.getTableList();
    });
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: 1, scope: 'searchList', query: 'comu_local_shop_apply_status'}
      ];
      this.dictionarySelect(paramArr);
    },
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) { return false; }
        this.toExamine(values);
      });
    },
    closeFun () {
      this.formList[1].isShow = false;
      this.visible = false;
    },
    toExamine (obj) {
      this.$put({
        url: '/local/shopApply/' + this.id,
        params: {
          ...obj
        }
      }).then((res) => {
        this.$message[obj.checkStatus == 3 ? 'success' : 'error'](obj.checkStatus == 3 ? '审核通过' : '审核已驳回');
        this.$refs.table.getTableList();
        this.closeFun();
      });
    },
    goDetail (id, status) {
      // this.setLocal('devQueryData', row);
      this.$router.push({ path: 'local/qualification/detail', query: {id, status} });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
</style>
